module.exports = __webpack_public_path__ + "img/paper-plane-icon.a46cbc4d.svg";